import {computed} from "vue";

export function useVModelInput(props, emit) {
    return computed({
        get: () => props['value'],
        set: (newVal) => emit('input', newVal)
    })
}